export default "__VITE_ASSET__BXfDhrHC__"